module.exports = __webpack_public_path__ + "img/NIA1.328d7049.jpg";